import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ssw/ssw.webp'


const _withScopeId = n => (_pushScopeId("data-v-75734f54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "container wrapper" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Stamford Sports Wheels",
  class: "img-fluid p-2"
}, null, -1))
const _hoisted_5 = { class: "menu_list" }
const _hoisted_6 = { class: "dropdown d-none d-lg-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-toggle",
  href: "#",
  id: "wheelBrandsDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Wheel Brands ", -1))
const _hoisted_8 = {
  class: "dropdown-menu",
  "aria-labelledby": "wheelBrandsDropdown"
}
const _hoisted_9 = { class: "d-block d-lg-none" }
const _hoisted_10 = { class: "d-block d-lg-none" }
const _hoisted_11 = { class: "d-block d-lg-none" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://orders.stamford.co.za/",
    target: "_blank"
  }, "B2B")
], -1))
const _hoisted_13 = { class: "btn_group_list d-flex d-lg-none" }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "btn_group_list d-none d-lg-flex" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: { path: '/'} }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("nav", {
        id: "navMenu",
        class: _normalizeClass(["menu", { active: _ctx.showMobileMenu }]),
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.showMobileMenu = false))
      }, [
        _createElementVNode("div", {
          id: "ToggleIcon",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.showMobileMenu = !_ctx.showMobileMenu)),
          class: _normalizeClass(["menu_bar close_toggle d-block d-lg-none", { active: _ctx.showMobileMenu }])
        }, null, 2),
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.goTO('sswAboutUs')))
            }, "ABOUT")
          ]),
          _createElementVNode("li", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { path: '/ssw-wheels'} }, {
                  default: _withCtx(() => [
                    _createTextVNode("SSW ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { path: '/diesel-wheels'} }, {
                  default: _withCtx(() => [
                    _createTextVNode("Diesel ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { path: '/flotec-wheels'} }, {
                  default: _withCtx(() => [
                    _createTextVNode("Flotec ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, { to: { path: '/ssw-wheels'} }, {
              default: _withCtx(() => [
                _createTextVNode("SSW Wheels ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, { to: { path: '/diesel-wheels'} }, {
              default: _withCtx(() => [
                _createTextVNode("Diesel Wheels ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, { to: { path: '/flotec-wheels'} }, {
              default: _withCtx(() => [
                _createTextVNode("Flotec Wheels ")
              ]),
              _: 1
            })
          ]),
          _hoisted_12,
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { path: '/downloads'} }, {
              default: _withCtx(() => [
                _createTextVNode("Downloads ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("ul", _hoisted_13, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.goTO('contactUsHome'))),
              class: "btn red_btn"
            }, "Contact Us")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              target: "_blank",
              href: _ctx.stamfordURL,
              class: "btn red_btn"
            }, "STAMFORD TYRES", 8, _hoisted_14)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              target: "_blank",
              href: _ctx.kumhoURL,
              class: "btn black_btn"
            }, "KUMHO TYRES", 8, _hoisted_15)
          ])
        ])
      ], 2),
      _createElementVNode("ul", _hoisted_16, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: "javascript:;",
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.goTO('contactUsHome'))),
            class: "btn red_btn"
          }, "Contact Us")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            target: "_blank",
            href: _ctx.stamfordURL,
            class: "btn black_btn"
          }, "STAMFORD TYRES", 8, _hoisted_17)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            target: "_blank",
            href: _ctx.kumhoURL,
            class: "btn black_btn"
          }, "KUMHO TYRES", 8, _hoisted_18)
        ])
      ]),
      _createElementVNode("div", {
        id: "ToggleIcon",
        onClick: _cache[5] || (_cache[5] = $event => (_ctx.showMobileMenu = !_ctx.showMobileMenu)),
        class: _normalizeClass(["menu_bar d-block d-lg-none", { active: _ctx.showMobileMenu }])
      }, null, 2),
      _createElementVNode("div", {
        id: "menuOverlay",
        onClick: _cache[6] || (_cache[6] = $event => (_ctx.showMobileMenu = !_ctx.showMobileMenu)),
        class: _normalizeClass(["menu_overlay d-block d-lg-none", { active: _ctx.showMobileMenu }])
      }, null, 2)
    ])
  ]))
}